import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCreateCalendarExportLinkRequestFailure() {
      return getState().isFailure;
    },
    isCreateCalendarExportLinkRequestPending() {
      return getState().isPending;
    },
    isCreateCalendarExportLinkRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
